// volume check receives strings and returns number
export const volumeCheck = (v: string) => {
    if (v === '') return 0.5
    if (v === null) return 0.5
    if (isNaN(+v)) return 0.5
    const volume = JSON.parse(v)
    if (volume > 1) return 1
    if (volume < 0) return 0
    return volume
}
